/**
 * 存管开户模块
 */
import domain from '@common/domain'
import cookie from 'js-cookie'
import ajax from '@finance/ajax'
// import { urlParams } from '@common/format'
import openNewView from '@common/client/src/newView'
import toast from '@common/toast'
import dialog from './dialog'

// 编码url
const serialiseUrl = (url, params) => {
  const newUrl = url + (url.indexOf('?') !== -1 ? '&' : '?')
  return newUrl + Object.keys(params).reduce((mem, key) => {
    mem.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
    return mem
  }, []).join('&')
}
// 非标账户地址
const accountProjectUrl = `${
  domain.res
  }/public-vue/fixin-account/index.html#/open`
// 跳转到非标账号页
const jumpToAccountProject = ({
  origin,
  forwardUrl,
  jumpType,
  newView,
  jumpToUrl = accountProjectUrl
}) => {
  const url = serialiseUrl(jumpToUrl, { origin, forwardUrl })
  if (newView) {
    openNewView(url)
  } else if (jumpType === 'replace') {
    location.replace(url)
  } else {
    location.href = url
  }
}
// 弹窗提示
const tips = {
  // 激活账户
  stocked: {
    handleConfirm: jumpToAccountProject
  },
  // 开新账户
  new: {
    handleConfirm: jumpToAccountProject
  },
  // 授权
  notAccredit: {
    handleConfirm: jumpToAccountProject
  },
  // 账户审核中
  checked: {
    title: '审核中',
    content:
      '您提交的资料正在审核中，请等待开户成功后再进行充值、提现和购买等操作，开户成功后我们会以短信的方式通知您',
    buttonText: '我知道了'
  },
  // 解锁
  locked: {
    title: '解锁银行存管账户',
    content: '您多次输错密码导致银行存管账户锁定，继续操作需解锁账户',
    buttonText: '去解锁',
    handleConfirm: (options) => {
      const jumpToUrl = `${
        domain.res
        }/public-vue/fixin-account/index.html#/safety/unlock`
      jumpToAccountProject({ ...options, jumpToUrl })
    }
  },
  // 解冻账户
  freezed: {
    title: '账户冻结',
    content: '账户已冻结，请解冻后再试',
    buttonText: '去解冻',
    handleConfirm: (options) => {
      const jumpToUrl = `${
        domain.res
        }/public-vue/fixin-account/index.html#/safety/unfreeze`
      jumpToAccountProject({ ...options, jumpToUrl })
    }
  },
  // 账户绑卡
  notBindCard: {
    title: '账户绑卡',
    content: '绑定银行卡后才能继续操作，请先绑卡',
    buttonText: '去绑卡',
    handleConfirm: (options) => {
      const jumpToUrl = `${
        domain.res
        }/public-vue/fixin-account/index.html#/manageCards/bind`
      jumpToAccountProject({ ...options, jumpToUrl })
    }
  }
}
// 判断用户是否登录
const isLoginCookie = () => {
  return cookie.get('isLogin') === 'true'
}

// 获取用户存管账户状态
const queryStatus = () => {
  if (isLoginCookie()) {
    return ajax
      .request({
        url: `${domain.api}/custodyws/ws/fixin/custody/investor/queryStatus`
      })
      .then((result) => {
        // 返回码100004表示当前用户id还未在存管账户表中，是新用户
        if (result.code === '100004') {
          const isOpen = false
          return isOpen
        }
        if (result.succeed) {
          return result.data
        }
        return Promise.reject(result.msg)
      })
  }
  console.warn('未登录情况下禁止调用开户状态判断')
  return Promise.reject('当前未登陆')
}

// 获取用户是否绑卡状态
const queryBindCard = () => {
  if (isLoginCookie()) {
    return ajax
      .request({
        url: `${domain.api}/custodyws/ws/fixin/custody/investor/isBindCard`
      })
      .then((result) => {
        if (result.succeed && result.data) {
          return result.data.isBindCard
        }
        return Promise.reject(result.msg)
      })
  }
  console.warn('未登录情况下禁止调用绑卡接口判断')
  return Promise.reject('当前未登陆')
}

/**
 * 处理已开户用户的各种异常状态
 * 参数说明：
 * registerStatus：开户状态【1:正常, 2:待处理, 3:确认中, 4:锁定, 5:失败, 6：冻结】
 * accreditStatus：授权状态【0:未授权, 1:已授权】
 * stockStatus：存量用户标识【0:存量未激活用户, 1:非存量用户】
 */
const handleStatus = ({ registerStatus, accreditStatus, stockStatus }) => {
  // stocked:存量待激活, pass:已开户, notAccredit:待授权, locked:待解锁, checked:审核中待确认, new:新用户, freezed:账户锁定
  if (registerStatus === 3) {
    return 'checked'
  } else if (registerStatus === 4) {
    return 'locked'
  } else if (registerStatus === 6) {
    return 'freezed'
  } else if (stockStatus === 0) {
    return 'stocked'
  } else if (registerStatus === 1 && accreditStatus === 1) {
    return 'pass'
  } else if (registerStatus === 1 && accreditStatus === 0) {
    return 'notAccredit'
  }

  return 'new'
}

class CustodyAccountAuth {
  dataable = null
  statusable = null
  bindCardable = null
  options = {}

  constructor({ prefetch = false } = {}) {
    if (prefetch) {
      this.prefetchStatus()
      this.prefetchBindCardStatus()
    }
  }
  // 预拉取用户状态
  prefetchStatus() {
    if (!this.dataable) {
      this.dataable = queryStatus()
      this.statusable = this.dataable.then(handleStatus)
    }
    return this
  }
  // 预拉取用户绑卡状态
  prefetchBindCardStatus() {
    if (!this.bindCardable) {
      this.bindCardable = queryBindCard()
    }
    return this
  }
  // 判断是否开户
  isOpenAccount() {
    this.prefetchStatus()
    return this.dataable.then((isOpen) => {
      return isOpen
        ? Promise.resolve()
        : Promise.reject({ type: 'new', msg: '未开户' })
    })
  }
  // 判断是否绑卡
  isBindCard() {
    this.prefetchBindCardStatus()
    return this.bindCardable.then((isBindCard) => {
      return isBindCard
        ? Promise.resolve()
        : Promise.reject({ type: 'notBindCard', msg: '未开户' })
    })
  }
  // 账户是否正常
  isNormal() {
    this.prefetchStatus()
    return this.statusable.then((type) => {
      return type === 'pass'
        ? Promise.resolve()
        : Promise.reject({ type, msg: '账户异常' })
    })
  }
  // 通过（账户无异常）
  pass({
    showTip = true, // 是否显示弹窗
    origin = '', // 开户来源，为了区分社区
    forwardUrl = location.href, // 开完户跳转的回调地址
    jumpType = 'href', // 开户链接的方式，支持'replace, href'两种方式
    newView = false, // 是否在当前窗口打开开户url
    openAccount = true, // 是否开户，如果showTip为true，忽略此参数
    showApiError = true // 是否提示接口错误异常
  } = {}) {
    this.options = {
      showTip,
      origin,
      forwardUrl,
      jumpType,
      newView,
      openAccount
    }
    return this.isOpenAccount()
      .then(this.isNormal.bind(this))
      .then(this.isBindCard.bind(this))
      .catch((error) => {
        if (error && error.type) {
          return showTip ? this.render(error) : Promise.reject(error)
        }
        showApiError && toast(error)
        return Promise.reject(error)
      })
  }
  render(error) {
    const { origin, forwardUrl, openAccount, jumpType, newView } = this.options
    const tip = tips[error.type]

    tip.handleConfirm =
      tip.handleConfirm &&
      tip.handleConfirm.bind(null, {
        origin,
        forwardUrl,
        jumpType,
        newView
      })
    if (tip.title) {
      dialog(tip)
    } else if (openAccount) {
      tip.handleConfirm()
    }
    return Promise.reject(error)
  }
}

export default class CustodyAccount {
  static custodyAccountAuth = null
  constructor(...args) {
    if (CustodyAccount.custodyAccountAuth) {
      return CustodyAccount.custodyAccountAuth
    }
    CustodyAccount.custodyAccountAuth = new CustodyAccountAuth(...args)
  }
  // eslint-disable-next-line
  pass(...args) {
    return CustodyAccount.custodyAccountAuth.pass(...args)
  }
  // eslint-disable-next-line
  isOpenAccount(...args) {
    return CustodyAccount.custodyAccountAuth.isOpenAccount(...args)
  }
}

// import CustodyAccountAuth from '@finance/CustodyAccountAuth'

// const custdoyAccount = new CustodyAccountAuth({ prefetch: false /* 预拉取接口账户状态接口，默认为false */ })

// // 账户正常通过
// custdoyAccount.pass({
//   showTip: true, // 是否显示弹窗
//   origin: '',  // 开户来源，为了区分社区
//   forwardUrl: location.href, // 开完户跳转的回调地址
//   jumpType: 'href', // 开户链接的方式，支持'replace, href'两种方式
//   newView: false, // 是否在当前窗口打开开户url
//   openAccount: true,  // 是否开户，如果showTip为true，忽略此参数
// }).then(() => {
//   // 通过，做你爱做的事
// }).catch(() => {
//   // 不通过
// })

// // 判断用户是否开户
// custdoyAccount.isOpenAccount().then(() => {
//   // 已开户，做你爱做的事
// }).catch(() => {
//   // 未开户
// })
